export enum AudioPlayerTypesEnum {

  FILE = 'file',
  SYNTHESIS = 'synthesis',

}
